<template>
  <base-form :loading="loading" :error-message="errorMessage" class="noprogress">
    <template v-slot:header>
      {{ $t('plan_customize_header') }}
    </template>
    <form class="boxForm_step5" @submit.prevent="" @submit="onSubmit">
      <div class="selectPlan">
        <div class="selectPlan__header">
          <div class="selectPlan__title">{{$t('renew_plan_policy_price')}} <span class="selectPlan__discount" v-if="schemeDiscount">&lrm;-{{schemeDiscount}}%</span></div>
        </div>
        <div class="switchQuote">
          <div class="switchQuote__container" v-for="(s, index) of schemes" :key="index">
            <input type="radio" name="policyPrice" :value="s.schemecode" v-model="schemeCode" :id="`${index}-scheme`"  @change="onSchemeChange(s)">
            <label :for="`${index}-scheme`">{{ s.price | splitNumber }}</label>
          </div>
        </div>
        <template v-if="productType==='car'">
          <div class="selectPlan__customize">
            <div class="selectPlan__customize-header">
              <div class="selectPlan__customize-title">{{$t('plan_customize_deductible')}}</div>
              <div class="selectPlan__customize-amount" v-if="deductiblePrice">{{$t('qic_qar')}} {{deductiblePrice | splitNumber}}</div>
              <div class="selectPlan__customize-amount" v-else>{{$t('qic_qar')}} 0</div>
            </div>
            <div class="selectPlan__customize-desc" >{{$t('plan_customize_deductible_desc')}}</div>
            <ul class="selectPlan__customize-list">
              <li
                v-for="(include, index) of filtredIncludedList"
                :class="include.included ? 'included' : 'not-included'"
                :key="index">
                {{include.title}}
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="selectPlan__header">
            <div class="selectPlan__title">{{$t('plan_inclusive_covers')}}</div>
          </div>
          <div class="baseAccordion">
            <BaseAccordion v-for="(include, index) of includedList" :key="index">
              <template v-slot:name>
                <div class="selectPlan-accordion__title">{{ include.name}}</div>
              </template>
              <template v-slot:content>
                <p>{{ include.description }}</p>
              </template>
            </BaseAccordion>
          </div>
        </template>
      </div>
      <BaseButton v-if="productType==='car'">
        {{$t('plan_customize_select', { price: $options.filters.splitNumber(schemePrice)})}}
      </BaseButton>
      <BaseButton v-else />
    </form>
  </base-form>
</template>

<script>
import { BaseAccordion, BaseForm } from 'qic-components'
import prodCodeMap from '@/assets/maps/prodCodeMap.json'
import { trackEvent, trackGtag } from '@/utils/useGtag'
import { getErrorMessage } from '@/shared/errors/getErrorMessage'

export default {
  name: 'SelectPlan',
  props: [
    'next'
  ],
  components: {
    BaseAccordion,
    BaseForm
  },
  data () {
    return {
      loading: false,
      errorMessage: null,
      schemes: [],
      schemeCode: null,
      allIncludes: [],
      productType: this.$store.state.renew.productType || '',
      policyInfo: this.$store.state.renew.policyInfo || {}
    }
  },
  computed: {
    submitDisabled () {
      return false
    },
    currentScheme () {
      return this.schemes.find(s => s.schemecode === this.schemeCode)
    },
    includedList () {
      return this.currentScheme ? this.currentScheme.included : []
    },
    filtredIncludedList () {
      const staticIncludes = this.productStaticIncludes.filter(s => !this.includedList.find(include => include.id === s.id))
      return [...staticIncludes, ...this.allIncludes.map((op) => ({
        title: op,
        included: this.includedList.some((i) => i.name === op)
      })).sort((a, b) => b.included - a.included)]
    },
    deductiblePrice () {
      return this.currentScheme?.deductible || 0
    },
    schemePrice () {
      return this.currentScheme ? this.currentScheme.price : 0
    },
    productStaticIncludes () {
      const includes = this.productInfo?.staticIncludes ? [...this.productInfo?.staticIncludes] : []
      return includes
        .map(i => {
          i.name = this.$t(i.name)
          i.description = this.$t(i.description)
          return i
        })
    },
    productInfo () {
      return prodCodeMap
        .filter(prod => prod.type === this.productType)
        .find(prod => prod.code === this.policyInfo?.prodCode)
    },
    locale () {
      return this.$i18n.locale
    },
    schemeDiscount () {
      return this.currentScheme ? Number((this.currentScheme.discount * 100 / this.currentScheme.fullPrice).toFixed(0)) : 0
    }
  },
  methods: {
    onSchemeChange (selectedScheme) {
      trackGtag('chooseComprehensiveType', {
        label: selectedScheme.price.toString(),
        text: selectedScheme.name
      })
    },
    onSubmit () {
      this.$store.commit('setRenewScheme', this.getSchemeInfo())
      trackEvent('select_for', 'car renew', null, null, this.currentScheme.name)
      trackGtag('click_proceed', {
        page: 'customize_policy',
        price: this.currentScheme.price,
        position: this.currentScheme.name
      })
      this.goNext()
    },
    goNext () {
      this.$router.push({ name: 'RenewQuote' })
    },
    getSchemeInfo () {
      return this.schemes.find(s => s.schemecode === this.schemeCode)
    }
  },
  mounted () {
    this.$store.dispatch('setUserLoginData', 'home_boat')
    this.loading = true
    this.$store.dispatch('getRenewSchemes')
      .then(schemes => {
        this.schemes = schemes
        this.schemeCode = schemes[0].schemecode
        if (this.schemes.length === 1) {
          this.$store.commit('setRenewScheme', this.getSchemeInfo())
          this.$router.replace({ name: 'RenewQuote' })
          return
        }
        this.allIncludes = [...this.schemes.reduce((acc, el) => {
          el.included.forEach((i) => acc.add(i.name))
          return acc
        }, new Set())]
      })
      .catch((error) => {
        this.errorMessage = getErrorMessage(error)
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<style lang="scss" scoped>
  .switchQuote {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
    &__container {
      width: 100%;
    }
  }
</style>
